import React from "react";
import "../../../css/overbox/Release.css";

const Release270 = props => {
    const { close } = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox release">
                    <h1 className={"title"}>Version 2.7.0</h1>
                    <p className={"date"}>Publiée le 16/03/2026</p>
                    <div className={"items"}>
                        <p className={"item"}>- Tableau de bord</p>
                        <p className={"item"}>- Centre de notifications</p>
                        <p className={"item"}>- Affichage des opérations en arrière plan</p>
                        <p className={"item"}>- Amélioration des filtres de recherche</p>
                        <a target="_blank" rel="noreferrer" href="https://www.skytill.fr/bienvenue-st3/"><p className={"item"}>Cliquer ici pour découvrir l'ensemble des nouveautés</p></a>
                    </div>
                    <div className="wrapButtons">
                        <p className="cancel marginBottom" onClick={ close }>Fermer</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Release270;
